import ITask from './ITask';
import Game from '../../Game';

export function* delay(duration: number): IterableIterator<number> {
    let elapsed = 0;

    while (elapsed < duration) elapsed += yield;
}

export default class TaskQueue<T> {
    public tasks: ITask<T>[];
    private running: boolean;
    private skip: boolean;
    private queueIterator: IterableIterator<any>;
    private queueResult: IteratorResult<any>;
    private currentTask: ITask<T>;

    constructor() {
        this.tasks = [];
        this.running = false;
    }

    public update() {
        if (this.queueResult && !this.queueResult.done) {
            this.queueResult = this.queueIterator.next(
                Game.ticker.getDeltaTime()
            );
        }
    }

    private *run(target: T): IterableIterator<number> {
        this.running = true;

        while (this.tasks.length > 0) {
            this.currentTask = this.tasks.shift();

            const taskIterator = this.currentTask.execute(target);
            let taskResult = taskIterator.next();

            while (taskResult && !taskResult.done && !this.skip) {
                taskResult = taskIterator.next(yield);
            }

            this.skip = false;
        }

        this.currentTask = null;
        this.queueResult = null;
        this.queueIterator = null;
        this.running = false;
    }

    public getCurrentTask(): ITask<T> {
        return this.currentTask;
    }

    public findTask<T>(type: { new (...args: any[]): T }): T {
        return [...this.tasks, this.getCurrentTask()].find(
            task => task instanceof type
        ) as any;
    }

    public isRunning(): boolean {
        return this.running;
    }

    public queue(task: ITask<T>) {
        this.tasks.push(task);
    }

    public queueNext(task: ITask<T>) {
        this.tasks.unshift(task);
    }

    public start(target: T) {
        if (this.isRunning()) return;
        if (this.tasks.length === 0) return;
        this.queueIterator = this.run(target);
        this.queueResult = this.queueIterator.next();
    }

    public next(): void {
        this.skip = true;
    }

    public clear() {
        this.tasks.length = 0;
        this.next();
    }
}
